/**
 * Headlines size
 */
export var HeadlineLevel;
(function (HeadlineLevel) {
    HeadlineLevel[HeadlineLevel["LEVEL1"] = 1] = "LEVEL1";
    HeadlineLevel[HeadlineLevel["LEVEL2"] = 2] = "LEVEL2";
    HeadlineLevel[HeadlineLevel["LEVEL3"] = 3] = "LEVEL3";
    HeadlineLevel[HeadlineLevel["LEVEL4"] = 4] = "LEVEL4";
    HeadlineLevel[HeadlineLevel["LEVEL5"] = 5] = "LEVEL5";
})(HeadlineLevel || (HeadlineLevel = {}));
export var HeadlineMarkup;
(function (HeadlineMarkup) {
    HeadlineMarkup["H1"] = "h1";
    HeadlineMarkup["H2"] = "h2";
    HeadlineMarkup["H3"] = "h3";
})(HeadlineMarkup || (HeadlineMarkup = {}));
//# sourceMappingURL=HeadlineEnum.js.map